import {DealSettings} from "@irati/types"
import perksSettingsService from "@irati/deals/services/perksSettings"
import authentication from "@irati/auth"

export const benefitsSchemeSettings = () => {
  const perksSettings: DealSettings = perksSettingsService.getSync(authentication.userTenant().uuid)
  return perksSettings.companyBenefits || {}
}
